import React, { useRef } from "react";

import Meta from "components/Meta";
import Layout from "components/Layout";
import { ResourceHubTemplateProps } from "../types";
import * as ResourceHub from "components/ResourceHub";
import NoResultsMessage from "components/NoResultsMessage";
import LoadMoreButton from "components/LoadMoreButton";

import * as gridStyles from "../Grid/styles.module.scss";

const Template: React.FC<ResourceHubTemplateProps> = ({
  activeBestPractices,
  activeContentType,
  activeTopics,
  defaultMeta,
  errorMessage,
  featuredPost,
  filterProps,
  handleLoadMoreClick,
  handlePopularSearchTag,
  isLoading,
  location,
  meta,
  popularSearchTags,
  resourceHubEntries,
  resultsRef,
  skeleton,
  totalRecords,
}) => {
  const containerRef = useRef<HTMLDivElement>(null);
  const showLoadMoreButton = resourceHubEntries && totalRecords !== 0 && totalRecords !== resourceHubEntries.length;

  return (
    <Layout>
      <Meta defaultMeta={defaultMeta} location={location} meta={meta} />
      <ResourceHub.Header forwardedContainerRef={containerRef}>
        <ResourceHub.Filter
          activeBestPractices={activeBestPractices}
          activeContentType={activeContentType}
          activeTopics={activeTopics}
          forwardedContainerRef={containerRef}
          isLoading={isLoading}
          {...filterProps}
        />
        {skeleton ? <ResourceHub.SkeletonFeatured /> : <ResourceHub.FeaturedBanner featuredPost={featuredPost} />}
        <ResourceHub.PopularSearch
          activeItems={[...activeBestPractices, ...activeContentType, ...activeTopics]}
          handlePopularSearchTag={handlePopularSearchTag}
          popularSearchTags={popularSearchTags}
          showActiveStyles={true}
        />
      </ResourceHub.Header>
      <div className="scrollContainer" ref={resultsRef}>
        <div className="container">
          <h2 className={gridStyles.heading}>Resource hub</h2>
          {skeleton && <ResourceHub.SkeletonGrid />}
          {totalRecords === 0 ? (
            <NoResultsMessage errorMessage={errorMessage} noContainer={true} />
          ) : (
            !skeleton && <ResourceHub.Grid entries={resourceHubEntries} />
          )}
          {totalRecords !== null && showLoadMoreButton && (
            <LoadMoreButton isLoading={isLoading} handleClick={handleLoadMoreClick} noContainer={true} />
          )}
        </div>
      </div>
    </Layout>
  );
};

export default Template;
